import EasyKeyboard from './keyboard';
export type {KeyboardConfig} from './keyboard';
export default EasyKeyboard;
